"use strict";

define('controller/reporting/detail',['require','exports','module','underscore','backbone','appkit/changes.helper','appkit/spf.helper','datakit/collection','../base','../../config','../../libs/route.helper','../../view/report/report.detail','../../view/report.preview.list','../../view/report/report.filter.bar','../../collection/base','../../model/report','../../model/report.column','../../model/report.type','langs'],function (require, exports, module) {
  'use strict';

  var _ = require('underscore');
  var Backbone = require('backbone');
  var ChangesHelper = require('appkit/changes.helper');
  var SPFHelper = require('appkit/spf.helper');
  var BaseCollection = require('datakit/collection');
  var RegionController = require('../base');
  var config = require('../../config');
  var RouteHelper = require('../../libs/route.helper');
  var ReportDetailView = require('../../view/report/report.detail');
  var ReportPreviewTable = require('../../view/report.preview.list');
  var ReportFilterBarView = require('../../view/report/report.filter.bar');
  var BaseCollection = require('../../collection/base');
  var ReportModel = require('../../model/report');
  var ReportColumns = require('../../model/report.column');
  var ReportType = require('../../model/report.type');
  var langs = require('langs');
  var p = langs.phrase;
  var ReportDetailController = RegionController.extend({
    header: p('App.Title'),
    authorities: ['PERM_MODIFY_REPORT'],
    features: ['reporting'],
    onStart: function onStart() {
      var self = this,
        app = this.app,
        state = this.state,
        region = this.region,
        report = new ReportModel({
          id: state.get('reportId')
        }),
        reportColumns = ReportColumns.all(),
        reportTypes = ReportType.all(),
        models = [reportTypes, reportColumns],
        changesHelper = new ChangesHelper().add(report),
        unsavedModal = app.request('modal', {
          type: 'UNSAVED_CHANGES',
          state: changesHelper
        }, {
          ariaControlsId: 'reportDetails'
        }),
        page = null;
      if (!report.isNew()) {
        report.fetch();
        models.push(report);
      } else {
        this.listenToOnce(report, 'sync', function () {
          app.navigate(RouteHelper.createLink('reporting:detail', report, {
            reportId: 'id'
          }), {
            trigger: false,
            replace: true
          });
        });
      }
      reportTypes.fetch().promise().tap(function () {
        var auditReportType = reportTypes.findWhere({
          name: 'IRB_Audit'
        });
        if (report.isNew()) {
          report.set('type', auditReportType);
          changesHelper.reset();
        }
        reportColumns.params({
          reportTypeId: auditReportType.get('id')
        });
        reportColumns.fetch();
      });
      this.listenTo(unsavedModal, 'save:model', function () {
        report.save();
      }).listenTo(report, 'request', function () {
        this.listenToOnce(report, 'sync', app.request('dimmer'));
      }).listenTo(report, 'destroy', function () {
        app.navigate('report/list', {
          trigger: true
        });
      });
      state.addPageDependencies(models).on('page:loaded', function () {
        var FILTER_FIELDS = [{
          displayName: p('SubmissionPage.VSFields.Analyst'),
          name: 'Analyst',
          autoComplete: {
            entity: 'person',
            field: 'fullName'
          }
        }, {
          displayName: p('SubmissionPage.VSFields.PrimaryReviewer'),
          name: 'PrimaryReviewer',
          autoComplete: {
            entity: 'person',
            field: 'fullName'
          }
        }, {
          displayName: p('SubmissionPage.VSFields.PI'),
          name: 'PrincipalInvestigator',
          autoComplete: {
            entity: 'person',
            field: 'fullName'
          }
        }, {
          displayName: p('SubmissionPage.VSFields.SubmissionType'),
          name: 'ProtocolType',
          autoComplete: {
            entity: 'template',
            field: 'type'
          }
        }, {
          displayName: p('SubmissionPage.VSFields.StudyExpirationDate'),
          name: 'StudyExpirationDate',
          type: 'date'
        }, {
          displayName: p('SubmissionPage.VSFields.StudyAdminCheckInDate'),
          name: 'StudyAdminCheckInDate',
          type: 'date'
        }, {
          displayName: p('SubmissionPage.VSFields.ProcessEndDate'),
          name: 'ProcessEndTime',
          type: 'date'
        }, {
          displayName: p('SubmissionPage.VSFields.SubmissionDate'),
          name: 'SubmissionDate',
          type: 'date'
        }];
        var reportFilterBarView = new ReportFilterBarView();
        if (!reportFilterBarView.spfHelper) {
          reportFilterBarView.spfHelper = new SPFHelper(new BaseCollection(), {});
        }
        var selectedFilters = report.get('filters');
        reportFilterBarView.setupVisualSearch(FILTER_FIELDS, state, selectedFilters);
        page = new ReportDetailView({
          model: report,
          columns: reportColumns,
          changesHelper: changesHelper,
          reportFilterBarView: reportFilterBarView,
          reportDetailsTitle: p('ReportingPage.Details.Title'),
          reportOptionsTitle: p('ReportingPage.Details.ReportOptions.Title'),
          reportFields: p('ReportingPage.Details.ReportFields.Title')
        });
        page.$el.css(config.contentCss);
        self.listenTo(reportFilterBarView.spfHelper.filter, 'change', function (e) {
          var changed = _.clone(e.attributes);
          report.setFilters(changed);
        }).listenTo(page, 'report:delete', function () {
          app.request('modal', {
            type: 'CONFIRM_DESTROY',
            name: report.get('name')
          }, {
            ariaControlsId: 'reportDetails'
          }).on('destroy:model', function () {
            unsavedModal.destroy();
            report.destroy();
          });
        }).listenTo(page, 'report:save', function () {
          report.save();
        }).listenTo(page, 'report:preview', function () {
          var results = new BaseCollection(),
            previewTable = new ReportPreviewTable({
              collection: results,
              columns: report.get('columns')
            });
          report.generateDefinitionResults().promise().tap(function (response) {
            results.reset(response.data.slice(0, 15));
            app.overlay.content.show(previewTable);
            app.overlay.content.$el.css('overflow-x', 'auto');
            app.overlay.header.text = 'Report Preview';
            app.overlay.subHeader.text = 'A sample generated report using the selected fields.';
            app.overlay.active = true;
          })["finally"](app.request('dimmer'));
        }).listenTo(page, 'report:export', function () {
          app.request('download', {
            formData: {
              v: 'csvh'
            },
            method: 'GET',
            url: report.generateDownloadUrl()
          });
        });
        region.show(page);
      });
    }
  });
  module.exports = ReportDetailController;
});

